import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {AppStore} from '../../stores/app.store';
import {MeService as ApiMeService} from '../../api/services/me.service';
import {AuthService} from '../auth/auth.service';
import {SnackbarService} from '../snackbar/snackbar.service';
import {take} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class PreferencesService {
    private readonly appStore = inject(AppStore);
    private readonly apiMeService = inject(ApiMeService);
    private readonly authService = inject(AuthService);
    private readonly snackbarService = inject(SnackbarService);

    public async showBeginnersHelp(enabled: boolean): Promise<void> {
        try {
            await firstValueFrom(this.apiMeService.MeUpdatePreferences({
                Authorization: await this.authService.getBearer(),
                preferencesUpdateData: { showBeginnersHelp: enabled }
            }));
            this.appStore.update({ preferences: { showBeginnersHelp: enabled } });
            if (enabled) {
                this.snackbarService.showSuccess('BEGINNERS_HELP.ENABLE_BEGINNERS_HELP_SUCCESSFUL');
            } else {
                this.snackbarService.showSuccess('BEGINNERS_HELP.DISABLE_BEGINNERS_HELP_SUCCESSFUL');
            }
        } catch (err) {
            if (enabled) {
                this.snackbarService.showError('BEGINNERS_HELP.ENABLE_BEGINNERS_HELP_ERROR_MSG', err as Error);
            } else {
                this.snackbarService.showError('BEGINNERS_HELP.DISABLE_BEGINNERS_HELP_ERROR_MSG', err as Error);
            }
            console.error(err);
        }
    }

    public async fetchPreferences(): Promise<void> {
        try {
            const preferences = await firstValueFrom(this.apiMeService.MeGetPreferences(await this.authService.getBearer())
                .pipe(take(1)));
            if (preferences) {
                this.appStore.update({ preferences });
            }
        } catch (error) {
            console.error(error);
        }
    }
}
